import React from "react";
import emojiRegex from "emoji-regex";
import { appleEmojiUrls } from "../../Core/utils/emojiUnified";

const replaceEmojisWithAppleImages = (text: string) => {
  const regex = emojiRegex();
  return text.replace(regex, (match) => {
    const { primary, fallback } = appleEmojiUrls(match);
    return `<img src="${primary}" alt="${match}" draggable="false" style="width:1.15em;height:1.15em;vertical-align:-0.2em;display:inline-block;" onerror="this.onerror=null;this.src='${fallback}';" />`;
  });
};

const ParseMentions = ({
  value = "",
  className = "bg-primary-500",
  textClassName = "out-300-14 text-gray-700 leading-[20px] ",
  clickDisable = false,
}) => {
  let newMessage = value || "";

  const urlRegex = /(https?:\/\/[^\s]+)/g;
  newMessage = newMessage.replace(urlRegex, (url) => {
    return `<${clickDisable ? "span" : "a"
      } class="text-primary-600 underline  out-300-14" href="${url}" target="_blank">${url}</${clickDisable ? "span" : "a"
      }>`;
  });

  newMessage = newMessage
    .split(`@@@__`)
    .join(
      ` <span class="bg-[#2e90fa] inline-block  w-max  px-2 rounded-lg whitespace-nowrap truncate out-500-12 leading-[18px] text-white" data-user-id=`
    );
  newMessage = newMessage.split(`^^__`).join('">@');
  newMessage = newMessage.split(`@@@^^^`).join("</span>");

  function parseMentionsMobile(message) {
    const regex = /@\[([\w\s]+)\]\((\d+)\)/g;
    const parsedMessage = message.replace(
      regex,
      '<span class="bg-[#2e90fa] inline-block w-max px-2 rounded-lg whitespace-nowrap truncate out-500-12 leading-[18px] text-white" data-user-id="$2">@$1</span>'
    );
    return parsedMessage;
  }

  newMessage = parseMentionsMobile(newMessage);

  // Must run AFTER url/mention parsing (so it doesn't touch the jsdelivr
  // URLs we're about to insert) and BEFORE the newline pass.
  newMessage = replaceEmojisWithAppleImages(newMessage);

  newMessage = newMessage.replace(/\n\r?/g, `<br />`);

  return (
    <p
      className={textClassName}
      dangerouslySetInnerHTML={{ __html: newMessage }}
    ></p>
  );
};

export default React.memo(ParseMentions);